import { useState, useCallback } from "react";
import { api } from "../../utils/api.js";
import { ENDPOINTS as E } from "../../utils/endpoints.js";
import messageService from "../../utils/MessageService.js";
import ok from "../../vendor/ok.svg";
import pencil from "../../vendor/pencil.svg";
import thrash from "../../vendor/thrash2.svg";
import "./Slider.css";

function Slider({
  data,
  setData,
  slides,
  position,
  shift,
  unit,
  setSendedObjects,
  sendMessage,
  toRight,
  autoTurn,
}) {
  const [edited, setEdited] = useState(false);
  const [updatedItem, setUpdatedItem] = useState(null);

  function resetEdition() {
    setEdited(false);
    setUpdatedItem(null);
  }

  function updateData() {
    const current = slides[position].identifier;
    const currElement = data.find((i) => i.identifier === current);
    currElement.is_sent = true;
    sendMessage(currElement);
    setSendedObjects((prev) => [...prev, currElement]);
    resetEdition();

    if (autoTurn) {
      toRight();
    }
  }

  function fixApplicantData(item, data, cell) {
    const dataParts = data.split("\n");
    const newData = dataParts[0];
    const digits = newData.replace(/\D/gi, "");
    const updates =
      cell === 1 ? { name: newData } : { phone: `7${digits.slice(1)}` };
    const res = {
      ...item,
      ...updates,
    };
    setUpdatedItem(res);
  }

  const updateApplicantData = useCallback(() => {
    if (!updatedItem) {
      resetEdition();
      return;
    }
    const current = slides[position].identifier;
    const currElement = data.find((i) => i.identifier === current);
    const { id, name, phone } = updatedItem;
    currElement.name = name;
    api
      .post(
        E.UPD_APPLICANT,
        3,
        { data: { id: +id, name, phone } },
        "информация автоматически обновится при возобновлении подключения"
      )
      .then((res) => {
        if (res.ok || (res.data === true && res.success === true)) {
          messageService.addSuccessMessage("Информация в БД обновлена");
        }
      });
    resetEdition();
  }, [slides, data, position, updatedItem, resetEdition]);

  function markRemoved(id) {
    api
      .post(
        E.MARK_REMOVED,
        3,
        { data: { id: +id } },
        "информация автоматически обновится при возобновлении подключения"
      )
      .then((res) => {
        if (res.ok || (res.data === true && res.success === true)) {
          messageService.addSuccessMessage("Отклик помечен удаленным в БД");
          resetEdition();
          const fil = slides.slice().filter((i) => i.id !== id);
          setData(fil);
        }
      });
  }

  return (
    <div className="slider">
      {slides.map((i, ind) => {
        return (
          <div key={ind} className="slider-item-wrapper">
            <div
              className={`Slider-slide ${
                position === 0 && ind === 0 && "Slider-slide--first"
              }
                ${
                  (i.additional_info || i.warning) && "Slider-slide_with_header"
                }`}
              style={{
                visibility: position === ind ? "visible" : "hidden",
                marginTop: 0,
                transform: ` translateX(-${position * shift}${unit})`,
              }}
            >
              {i.warning || i.additional_info ? (
                <div
                  className={`Slider-slide-header ${
                    i.additional_info && i.warning
                      ? "Slider-slide-header_gray"
                      : i.additional_info
                      ? "Slider-slide-header_green"
                      : "Slider-slide-header_red"
                  }`}
                >
                  <h2 className="Slider-slide-header_icon">!</h2>
                  <h2 className="Slider-slide-header_text">
                    {i.additional_info && i.warning
                      ? "ПРОБЛЕМЫ В ТАБЛИЦЕ, ОТКЛИК НЕ ОТПРАВЛЕН"
                      : i.additional_info
                      ? i.additional_info
                      : "ПОДОЗРЕНИЕ НА НЕНОРМАТИВНУЮ ЛЕКСИКУ"}
                  </h2>
                </div>
              ) : null}
              <div style={{ position: "relative", width: "100%" }}>
                <div className="Slider-slide-content">
                  <h2 className="Slider-slide-text">{i.ink}</h2>
                </div>
                <div className="Slider-slide-content">
                  {!edited ? (
                    <div className="Slider-slide-text_content">
                      <h3 className="Slider-slide-text">
                        Поступил новый отклик:
                      </h3>
                      <h3 className="Slider-slide-text">
                        <span>Вакансия:&nbsp;</span>
                        {i.vacancy}
                      </h3>
                      <h3 className="Slider-slide-text">
                        <span>ФИО соискателя:&nbsp;</span>
                        {i.name}
                      </h3>
                      <h3 className="Slider-slide-text">
                        <span>
                          {`Контакт для связи${
                            i.phone ? ": " : " отсутствует"
                          }`}
                        </span>
                        {i.phone ? i.phone : ""}
                      </h3>
                    </div>
                  ) : (
                    <>
                      <textarea
                        onChange={(e) => {
                          fixApplicantData(i, e.target.value, 1);
                        }}
                      >{`${i.name}`}</textarea>
                      <textarea
                        onChange={(e) => {
                          fixApplicantData(i, e.target.value, 2);
                        }}
                      >{`${i.phone}`}</textarea>
                    </>
                  )}
                </div>
              </div>
              <div className="Slider-slide_buttons">
                <button
                  style={{ background: "var(--t-color1)" }}
                  onClick={() => updateData()}
                >
                  Отправить в ЛК
                  <img src={ok} alt="send" />
                </button>
                <button
                  style={{ background: "var(--bg-color2)" }}
                  onClick={
                    !edited ? () => setEdited(true) : updateApplicantData
                  }
                >
                  {!edited ? "Редактировать" : "Сохранить в БД"}
                  <img
                    src={!edited ? pencil : ok}
                    alt={!edited ? "Редактировать" : "Сохранить в БД"}
                    title={!edited ? "Редактировать" : "Сохранить в БД"}
                    style={{ cursor: "pointer" }}
                    className="Slider-slide-link"
                  />
                </button>
                <button
                  style={{ background: "var(--t-color2)" }}
                  onClick={() => markRemoved(i.id)}
                >
                  Удалить
                  <img src={thrash} alt="clean" />
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Slider;
